export const SORT_OPTIONS = [
  {column: 'date', desc: true},
  {column: 'date', desc: false},
  {column: 'count', desc: true},
  {column: 'count', desc: false},
];
